export enum ViewMode {
  LIST_VIEW = 1,
  CARD_VIEW = 2,
}
